<template>
  <DragPanel
    title="锚点"
    :closePanel="closePanel"
    :tooltipVisible="false">
    <div
      class="anchor-opertion-box"
      v-if="isChecked('Project.Single.SceneAnchorPoint.Operate')">
      <el-button
        type="primary"
        class="primary-btn primary-ang-btn"
        size="small"
        icon="el-icon-plus"
        :disabled="isDisabledBtn"
        @click="openAddAnchorDialog(null)">
        新建锚点
      </el-button>
      <el-button
        type="primary"
        class="normal-btn normal-ang-btn"
        size="small"
        icon="el-icon-plus"
        :disabled="isDisabledBtn"
        @click="openAddAnchorGroupDialog">
        添加分组
      </el-button>
    </div>
    <div class="anchor-filter-box">
      <div class="label-box">锚点类型：</div>
      <el-select
        class="primary-select"
        size="small"
        v-model="anchorPointTypeId"
        clearable
        :disabled="isDisabledBtn"
        :popper-append-to-body="false"
        @focus="initAnchorTypeList()"
        @change="updateAnchorList">
        <el-option
          v-for="(item, index) in anchorTypeList"
          :key="index"
          :label="item.typeName"
          :value="item.typeId">
          <div
            class="text-overflow"
            :title="item.typeName">
            {{ item.typeName }}
          </div>
        </el-option>
      </el-select>
    </div>
    <AnchorList
      :isDisabledBtn="isDisabledBtn"
      :anchorList="filterAnchorList"
      @openAnchorDialog="openAddAnchorDialog"
      @openAnchorDetailsPanel="openAnchorDetailsPanel"
      @openDeleteGroupDialog="openDeleteGroupDialog"
      :refreshAnchorList="refreshAnchorList" />
    <AnchorDetailsPanel
      v-if="isAnchorDetailsPanelVisible"
      :anchorDetails="anchorDetails"
      @closeAnchorDetailsPanel="closeAnchorDetailsPanel" />
    <div
      class="switch-box"
      v-if="isChecked('Project.Single.Scene.Edit')">
      <div>场景预览时锚点始终可见：</div>
      <el-switch
        class="switch-primary"
        v-model="enableAnchorPointShow"
        :disabled="isDisabledBtn"
        @change="updateAnchorShowStatus" />
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import AnchorList from './AnchorList.vue'
import AnchorDetailsPanel from './AnchorDetailsPanel.vue'

import { Store } from '@/utils/store'

import {
  getAnchorTypeListService,
  getSceneAnchorListService
} from '@/service/interface.js'

import { updateAnchorShowStatusService } from '@/service/anchor/index.js'

// prettier-ignore
const animAnchorPicPath = "https://demo.bjblackhole.com/css/img/anc_anim - 副本.png";

// prettier-ignore
const mergePicPath = 'https://demo.bjblackhole.com/demopage/examplesImgs/bubbler.png';

export default {
  data() {
    return {
      // 是否禁用所有操作，创建和编辑锚点时需要禁用所有操作
      isDisabledBtn: false,

      anchorPointTypeId: '',
      anchorTypeList: [],
      originAnchorList: [],
      filterAnchorList: [],

      isAnchorDetailsPanelVisible: false,
      anchorDetails: {},
    }
  },
  props: {
    enableAnchorPointShow: Boolean
  },
  components: {
    DragPanel,
    AnchorList,
    AnchorDetailsPanel
  },
  mounted() {
    this.initData()
  },
  beforeDestroy() {},
  methods: {
    async initData() {
      this.anchorTypeList = await this.queryAnchorTypeList()
      this.initAnchorList().then(() => {
        this.addAnchlorList(this.filterAnchorList)
      })
    },
    async initAnchorTypeList() {
      this.anchorTypeList = await this.queryAnchorTypeList()
    },
    initAnchorList() {
      return new Promise(resolve => {
        this.queryAnchorList().then(anchorList => {
          this.originAnchorList = anchorList
          this.filterAnchorList = anchorList
          resolve()
        })
      })
    },
    updateAnchorList(value) {
      const BlackHole3D = window.BlackHole3D
      let groupIds = this.originAnchorList.map(item => item.groupId)
      groupIds.forEach(groupId => {
        BlackHole3D.Anchor.delGroupAnc(groupId)
      })

      let filterAnchorList = []
      this.originAnchorList.forEach(item => {
        let anchorPointList = item.anchorPointList.filter(anchor => {
          if (value) {
            return anchor.anchorPointTypeId === value
          } else {
            return true
          }
        })
        let obj = { ...item }
        obj.anchorPointList = anchorPointList
        filterAnchorList.push(obj)
      })
      this.filterAnchorList = filterAnchorList
      this.addAnchlorList(filterAnchorList)
    },
    async updateAnchorShowStatus(enableAnchorPointShow) {
      let sceneId = this.$route.query.sceneId
      const params = { sceneId, enableAnchorPointShow }
      const response = await updateAnchorShowStatusService(params)
      if (response.isSuccess) {
        this.$message.success('更改锚点常显状态成功')
        this.$emit('UpdateSceneInfo')
      } else {
        this.$message.error(response.errMsg)
      }
    },
    openAddAnchorDialog(anchorInfo) {
      this.isDisabledBtn = true
      this.$emit('openAnchorDialog', anchorInfo)
    },
    enableBtn() {
      this.isDisabledBtn = false
    },
    openAddAnchorGroupDialog() {
      this.$emit('openAnchorGroupDialog')
    },
    openDeleteGroupDialog(groupIdToDelete) {
      this.$emit('openDeleteGroupDialog', groupIdToDelete)
    },
    closePanel() {
      if (!this.enableAnchorPointShow) {
        const BlackHole3D = window.BlackHole3D
        BlackHole3D.Anchor.delAllAnc()
      }

      this.$emit('closeAnchorPanel')
    },
    openAnchorDetailsPanel(anchorDetails) {
      this.anchorDetails = anchorDetails
      this.isAnchorDetailsPanelVisible = true
    },
    closeAnchorDetailsPanel() {
      this.anchorDetails = {}
      this.isAnchorDetailsPanelVisible = false
    },
    addAnchlorList(anchorGroupList) {
      const BlackHole3D = window.BlackHole3D

      let normalAnchorList = []
      let animAnchorList = []
      anchorGroupList.forEach(item => {
        let anchorList = item.anchorPointList
        anchorList.forEach(anchor => {
          let visibleDistanceUnit = anchor.visibleDistanceUnit
          let scalingThresholdUnit = anchor.scalingThresholdUnit
          // prettier-ignore
          let selfAutoScaleDist = scalingThresholdUnit === "Kilometer" ? anchor.scalingThreshold * 1000 : anchor.scalingThreshold;
          // prettier-ignore
          let selfVisDist = visibleDistanceUnit === "Kilometer" ? anchor.visibleDistance * 1000 : anchor.visibleDistance;

          let anchorInfo = {
            groupName: item.groupId,
            ancName: anchor.sceneAnchorPointId,
            pos: JSON.parse(anchor.position),
            textInfo: anchor.name,
            picWidth: 32,
            picHeight: 32,
            selfAutoScaleDist: selfAutoScaleDist,
            selfVisDist: selfVisDist,
            texBias: [0, 1],
            texFocus: [16, 0],
            textClr: new BlackHole3D.REColor(255, 255, 255, 255),
            useLod: item.aggregationStatus ? true : false
          }

          if (anchor.displayForm === 0) {
            let timestamp = new Date().getTime()
            let picPath = `${window.imageBaseUrl}/${anchor.iconUrl}?timestamp=${timestamp}`
            anchorInfo.ancSize = 32
            anchorInfo.picPath = picPath
            const isAnchorExist = BlackHole3D.Anchor.getAnc(anchorInfo.ancName)
            if (!isAnchorExist) {
              normalAnchorList.push(anchorInfo)
            }
          } else {
            anchorInfo.picPath = animAnchorPicPath
            anchorInfo.picNum = 6
            anchorInfo.playFrame = 2
            const isAnchorExist = BlackHole3D.Anchor.getAnc(anchorInfo.ancName)
            if (!isAnchorExist) {
              animAnchorList.push(anchorInfo)
            }
          }
        })
      })

      if (normalAnchorList.length) {
        BlackHole3D.Anchor.addAnc(normalAnchorList)
      }

      if (animAnchorList.length) {
        BlackHole3D.Anchor.addAnimAnc(animAnchorList)
      }

      if (!normalAnchorList.length && !animAnchorList.length) return

      let mergeGroup = anchorGroupList.filter(el => el.aggregationStatus)
      let mergeAnchorGroupList = []

      const mergestyle = new BlackHole3D.REAncInfo()
      mergestyle.picPath = mergePicPath
      mergestyle.picWidth = 32
      mergestyle.picHeight = 32
      mergestyle.textBias = [1, 0]
      mergestyle.fontName = 'RealBIMFont001'
      mergestyle.textClr = new BlackHole3D.REColor(255, 255, 255, 255)

      mergeGroup.forEach(item => {
        let ancLODInfo = new BlackHole3D.REAncLODInfo()
        ancLODInfo.groupName = item.groupId
        ancLODInfo.lodLevel = 10
        ancLODInfo.useCustomBV = false
        ancLODInfo.customBV = []
        ancLODInfo.lodMergePxl = 300.0
        ancLODInfo.lodMergeCap = 2
        ancLODInfo.mergeStyle = mergestyle
        mergeAnchorGroupList.push(ancLODInfo)
      })

      mergeAnchorGroupList.forEach(item => {
        BlackHole3D.Anchor.setAncLODInfo(item)
      })
    },
    refreshAnchorList() {
      return new Promise(resolve => {
        this.anchorPointTypeId = ''
        this.queryAnchorList().then(anchorList => {
          this.originAnchorList = anchorList
          this.filterAnchorList = anchorList
          resolve()
        })
      })
    },
    reRnderAnchor(isMigrationGroup, originGroupId, targetGroupId) {
      const BlackHole3D = window.BlackHole3D

      let originAnchorList = this.filterAnchorList.filter(
        el => el.groupId === originGroupId
      )
      BlackHole3D.Anchor.delGroupAnc(originGroupId)

      if (isMigrationGroup) {
        originAnchorList.forEach(anchor => {
          anchor.groupId = targetGroupId
        })
        this.addAnchlorList(originAnchorList)
      }
    },
    async queryAnchorTypeList() {
      let projectZoneId = this.$route.params.projId
      let response = await getAnchorTypeListService({ projectZoneId })
      if (response.isSuccess) {
        let data = response.data
        let anchorTypeList = data.map(item => {
          item.typeName = item.name
          item.typeId = item.anchorPointTypeId
          return item
        })
        return anchorTypeList
      } else {
        this.$message.error(response.errMsg)
      }
    },
    queryAnchorList() {
      return new Promise(resolve => {
        let sceneId = this.$route.query.sceneId
        getSceneAnchorListService(sceneId).then(response => {
          if (response.isSuccess) {
            let anchorList = response.data
            anchorList.forEach(item => {
              item.originGroupName = item.groupName
              let anchorPointList = item.anchorPointList
              anchorPointList.forEach(anchorInfo => {
                anchorInfo.groupName = item.groupName
              })
            })
            resolve(anchorList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.common-drag-panel {
  top: 214px;
  right: 20px;
  width: 360px;
  min-width: 360px;
  height: calc(100% - 225px);

  :deep(.content) {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);
    padding: 8px 16px 16px 16px;

    .anchor-opertion-box {
      display: flex;
      align-items: center;

      .el-button {
        flex: 1;
        span {
          display: inline;
        }
      }
    }

    .anchor-filter-box {
      display: flex;
      align-items: center;
      margin-top: 8px;
      font-size: 14px;

      .label-box {
        flex-shrink: 0;
      }

      .primary-select {
        flex-grow: 1;

        .el-select-dropdown {
          width: 100%;
        }
      }
    }

    .switch-box {
      display: flex;
      align-items: center;
      width: calc(100% + 32px);
      margin-left: -16px;
      padding: 10px 16px 0px;
      font-size: 14px;
      border-top: 1px solid var(--dialog-split-line-color);
    }
  }
}
</style>
